const map = {
	"./Alinna Villaroman.png": 795,
	"./Anju Natarajan.png": 669,
	"./Anoushka Adusumalli.png": 4,
	"./Ashley Tan.jpg": 44,
	"./Erik Fong.jpg": 236,
	"./Grace Isaac.jpg": 990,
	"./Hargun Chhabra.jpg": 631,
	"./Helen Li.png": 444,
	"./Isabella Lake.jpg": 951,
	"./Jacob Park.jpg": 136,
	"./Jessica Patrick.jpg": 963,
	"./Jiwon Shin.jpg": 8,
	"./Kayli Huang.jpg": 60,
	"./Kelly Yu.jpeg": 135,
	"./Maryam Akelyan.jpeg": 186,
	"./Michael Egan.jpeg": 252,
	"./Pranavi Oduru.jpg": 557,
	"./Riya Singh.jpg": 697,
	"./Ryan Alavi.jpg": 326,
	"./Saesha Sharda.jpg": 477,
	"./Sanchitha Kannabran.jpg": 370,
	"./Sanya Singh.jpeg": 933,
	"./Steven Zhang.jpeg": 605
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;